module.exports = __webpack_public_path__ + "static/media/logo_test.854b5c6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/logo_test.svg
// module id = 1852
// module chunks = 4